import NLS                  from "dashboard/dist/Core/NLS";
import Status               from "dashboard/dist/Core/Status";
import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";

// Types
import {
    LOC_ROOM_LOADING,
    LOC_ROOM_LIST, LOC_ROOM_ELEM,
} from "Utils/Types";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    sort      : {
        orderBy  : "createdTime",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate            = DateTime.formatDate(elem.createdTime, "dashes");
    elem.createdDateTime        = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.forStrechesString      = Utils.toYesBlank(elem.forStreches);
    elem.forConversationsString = Utils.toYesBlank(elem.forConversations);
    elem.forMeetingsString      = Utils.toYesBlank(elem.forMeetings);
    elem.floorName              = NLS.formatIf("ROOMS_FLOOR_NAME", elem.floor);
    elem.statusName             = Status.getName(elem.status);
    elem.statusColor            = Status.getColor(elem.status);
    elem.statusClass            = Status.getTextClass(elem.status);
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, LOC_ROOM_LIST, LOC_ROOM_ELEM)) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case LOC_ROOM_LOADING:
        return {
            ...state,
            loading   : true,
        };

    case LOC_ROOM_LIST:
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : parseList(action.data.list),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case LOC_ROOM_ELEM:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            canEdit   : action.data.canEdit,
            elem      : parseElem(action.data.elem),
        };

    default:
        return state;
    }
};

export default reducer;
